// Copy of a keyed record with `key` set to `value`, or removed when `value` is null —
// for the per-product maps the wizard keeps in signals.
export function withKey<T>(record: Readonly<Record<number, T>>, key: number, value: T | null): Record<number, T> {
    const next = { ...record };
    if (value == null) {
        delete next[key];
    } else {
        next[key] = value;
    }
    return next;
}
